import React from "react";
import { useContext } from "react"
import { PatientProfileContext } from "./context";

export const usePatientProfile = () => {
    const context = useContext(PatientProfileContext);

    if (!context)    
      throw new Error('usePatientProfile must be used within a PatientProfileProvider');
    
    return context;
}
